export const PRIVACY_POLICY_URL = 'https://itsgoodlife.co/privacy'
export const TERMS_URL = 'https://itsgoodlife.co/terms'
